<template>
  <f7-page name="price">
    <f7-navbar
      title="Прайс-лист"
      back-link-force
      back-link-url="/"
      back-link
    ></f7-navbar>
    <div id="categories">
      <f7-block-title>Тип</f7-block-title>
      <f7-list no-hairlines-md>
        <f7-list-input
          name="id"
          v-model="form"
          :value="form"
          @input="form = $event.target.value"
          type="select"
          placeholder="Выберите тип авто..."
        >
          <option
            v-for="(category, index) in categories.data"
            :key="index"
            :value="category.id"
          >
            {{ category.attributes.title }}
          </option>
        </f7-list-input>
      </f7-list>

      <f7-block-title>Услуги</f7-block-title>
      <f7-col v-show="preloader" class="text-align-center">
        <f7-preloader></f7-preloader>
      </f7-col>
      <f7-list media-list>
        <f7-list-item
          v-for="(service, index) in services.data"
          :key="index"
          checkbox
          name="services"
          :value="service.id"
          :title="service.attributes.title"
          v-bind:after="price(service.attributes.price)"
          v-bind:text="service.attributes.body"
        >
          <div slot="after-start">
            <span
              class="text-color-gray"
              style="margin-right: 6px; font-size: smaller; white-space: nowrap"
              >{{ service.attributes.duration }} мин.</span
            >
          </div>
        </f7-list-item>
      </f7-list>
    </div>
  </f7-page>
</template>
<script>
export default {
  data() {
    return {
      preloader: true,
      categories: "",
      services: "",
      form: "10",
    };
  },
  watch: {
    form: function () {
      this.checkForm();
    },
  },
  methods: {
    price(price) {
      return parseInt(price).toLocaleString("ru-RU") + ` ₽`;
    },
    checkForm() {
      this.getServices();
    },
    getServices() {
      this.$f7ready((f7) => {
        let that = this;
        var category = this.$f7.form.convertToData("#categories");

        let getData = {
          filter: {
            category_id: category.id == "" ? this.form : category.id,
          },
        };
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/services",
          method: "GET",
          dataType: "json",
          data: getData,
          success: function (data, status) {
            if (data.data != null) {
              that.services = data;
              that.preloader = false;
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(error.detail, "Ошибка " + error.status);
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
    getCategories() {
      this.$f7ready((f7) => {
        // Call F7 APIs here
        let that = this;
        let getData = {
          filter: {
            group_id: 0,
          },
        };
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/categories",
          method: "GET",
          dataType: "json",
          data: getData,
          success: function (data, status) {
            if (data.data != null) {
              that.categories = data;
              that.getServices();
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(error.detail, "Ошибка " + error.status);
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
  },
  mounted: function () {
    this.getCategories();
  },
};
</script>
